exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".konva-wrapper{background:transparent;position:absolute;top:0}\n", ""]);
